import React from 'react';

const Vue_Instance_Options_props = () => {
  return (
    <div>
      <h1>Vue_Instance_Options_props Component</h1>
      <p>This is the Vue_Instance_Options_props tutorial page.</p>
    </div>
  );
}

export default Vue_Instance_Options_props;
